import { render, staticRenderFns } from "./market-controls.component.vue?vue&type=template&id=3cbe4e6e&scoped=true"
import script from "./market-controls.component.vue?vue&type=script&lang=ts"
export * from "./market-controls.component.vue?vue&type=script&lang=ts"
import style0 from "./market-controls.component.vue?vue&type=style&index=0&id=3cbe4e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe4e6e",
  null
  
)

export default component.exports